<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg699"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs703"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath713"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path711" /></clipPath></defs><g
     id="g705"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g707"><g
         id="g709"
         clip-path="url(#clipPath713)"><g
           id="g715"
           transform="translate(220,292)"><path
             d="m 0,0 c 0,-22.091 -17.909,-40 -40,-40 h -120 c -22.091,0 -40,17.909 -40,40 v 160 c 0,22.091 17.909,40 40,40 h 120 c 22.091,0 40,-17.909 40,-40 z"
             style="stroke:#000000;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path717" /></g><g
           id="g719"
           transform="translate(492,60)"><path
             d="m 0,0 c 0,-22.091 -17.909,-40 -40,-40 h -120 c -22.091,0 -40,17.909 -40,40 v 160 c 0,22.091 17.909,40 40,40 h 120 c 22.091,0 40,-17.909 40,-40 z"
             style="stroke:#000000;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path721" /></g><g
           id="g723"
           transform="translate(220,60)"><path
             d="m 0,0 c 0,-22.091 -17.909,-40 -40,-40 h -120 c -22.091,0 -40,17.909 -40,40 v 80 c 0,22.091 17.909,40 40,40 h 120 c 22.091,0 40,-17.909 40,-40 z"
             style="stroke:#000000;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path725" /></g><g
           id="g727"
           transform="translate(492,372)"><path
             d="m 0,0 c 0,-22.091 -17.909,-40 -40,-40 h -120 c -22.091,0 -40,17.909 -40,40 v 80 c 0,22.091 17.909,40 40,40 h 120 c 22.091,0 40,-17.909 40,-40 z"
             style="stroke:#000000;stroke-width:40;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path729" /></g></g></g></g></svg>
</template>
